import React, { useState,useRef,useEffect } from "react";

import AdminPage from "../AdminPage";
import axios from "axios";
import { SERVERURL } from "../../../ServerUrl";
import Swal from "sweetalert2";



const COPY = {
  title: "Add Podcast",
  subtitle: "Upload New Podcast",
  podcastTitle: "Title",
  titlePlaceholder: "Title of Podcast",
  link: "Youtube Video Link",
  linkPlaceholder: "Link of Podcast",
  thumbnail: "Thumbnail Image",
  upload: "Upload",
};

const AddPodcast = () => {
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [thumbnail, setThumbnail] = useState(null); // State for thumbnail
  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };
  const handleLinkChange = (e) => {
    setLink(e.target.value);
  };
  const handleThumbnailChange = (e) => {
    setThumbnail(e.target.files[0]); // Get the selected file
  };
  const [errors, setErrors] = useState({});
  
  const validateForm = () => {
    const errors = {};

    if (!title.trim()) {
      errors.title = "Title is required";
    } else if (title.length > 50) {
      errors.title = "Title must be less than 50 characters";
    }

    if (!link) {
      errors.link = "Link is required";
    }
    
    if (!thumbnail) {
      errors.thumbnail = "Thumbnail Image is required"; 
    }
    
    setErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const uploadOnServer = async () => {
    if (!validateForm()) {
      return;
    }
    try {

      const form = new FormData();
      form.append("title", title);
      form.append("link", link);
      form.append("thumbnail", thumbnail);
      const token = localStorage.getItem('token'); 
      const headers = {
        'Authorization': `Bearer ${token}`, // Corrected header format
      };
      const response = await axios.post(`${SERVERURL}/api/v1/AddPodcast`, form, {
        headers: headers, // Include the headers object in the request configuration
      });

          if(response.data.success === true)
          {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Podcast Added Successfully.",
            }).then(() => {
              window.location.reload(); // Reload after the alert is closed
            });
          }
          else {
            Swal.fire({
              icon: "error",
              title: response.data.message,
             text: "",
            });
          }
      
          
        } catch (error) {
      Swal.fire({
        icon: "error",
        title: "An error occurred",
        text: "Podcast Not Added.",
      });
      console.error("Error adding podcast:", error);
    }
  };
  return (
    <AdminPage title={COPY.title} subtitle={COPY.subtitle}>
      <div className="admin-card" style={{ maxWidth: "560px" }}>
        <div className="admin-form-grid">
          <div className="admin-field">
            <label className="admin-label" htmlFor="title">
              {COPY.podcastTitle}
            </label>
            <input
              id="title"
              type="text"
              placeholder={COPY.titlePlaceholder}
              className="admin-input"
              value={title}
              onChange={handleTitleChange}
            />
            {errors.title && <p className="admin-error">⚠ {errors.title}</p>}
          </div>

          <div className="admin-field">
            <label className="admin-label" htmlFor="link">
              {COPY.link}
            </label>
            <input
              id="link"
              type="text"
              placeholder={COPY.linkPlaceholder}
              className="admin-input"
              value={link}
              onChange={handleLinkChange}
            />
            {errors.link && <p className="admin-error">⚠ {errors.link}</p>}
          </div>

          <div className="admin-field">
            <label className="admin-label" htmlFor="thumbnail">
              {COPY.thumbnail}
            </label>
            <input
              id="thumbnail"
              type="file"
              accept="image/*"
              className="admin-input admin-file"
              onChange={handleThumbnailChange}
            />
            {errors.thumbnail && (
              <p className="admin-error">⚠ {errors.thumbnail}</p>
            )}
          </div>
        </div>

        <div className="admin-form-actions">
          <button className="admin-btn" type="button" onClick={uploadOnServer}>
            {COPY.upload}
          </button>
        </div>
      </div>
    </AdminPage>
  );
};

export default AddPodcast;
